module.exports = __webpack_public_path__ + "img/logo.9633d0b2.png";